/* istanbul ignore file */
const MODULE_NAME = "sc/actions/common/";

export const RECEIVED_UNSTABLE_FEATURES_STATUS = `@@${MODULE_NAME}RECEIVED_UNSTABLE_FEATURES_STATUS`;

export const receivedUnstableFeaturesStatus = status => ({
  type: RECEIVED_UNSTABLE_FEATURES_STATUS,
  payload: {
    retrieved: true,
    ...status,
  },
});



// WEBPACK FOOTER //
// ./src/sc/actions/unstable-features-status.js